import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import Colors from '../../theme/colors';
import Icon from '../Icon';
import {
  QuoteContainer,
  QuoteTypography,
  QuoteFigure,
} from './styles';

// Centered quotes can ONLY have the Quotation icon for decoration
// Left aligned quotes can ONLY have the left border for decoration

export const QuoteComponent = ({
  text,
  textProps,
  color,
  borderColor,
  hasBorder,
  hasQuotationIcon,
  figcaption,
  cite,
  centered,
}) => (
  <QuoteFigure
    style={{
      textAlign: centered
        ? 'center'
        : 'left',
    }}>
    {hasQuotationIcon && centered && <Icon variant="quotation" />}
    <QuoteContainer
      hasBorder={centered
        ? false
        : hasBorder}
      borderColor={borderColor}>
      <QuoteTypography
        color={color}
        variant="h2"
        disableBottomPadding
        {...textProps}>
        &#34;{text}&#34;
      </QuoteTypography>
    </QuoteContainer>
    {(figcaption || cite) && (
      <figcaption hasBorder={hasBorder}>
        <Typography color={color} component="p" disableBottomPadding>
          {figcaption && <span>&#8211;{figcaption}</span>}
          {figcaption && cite && <span>, </span>}
          {cite && <cite>{cite}</cite>}
        </Typography>
      </figcaption>
    )}
  </QuoteFigure>
);

QuoteComponent.propTypes = {
  text: PropTypes.string.isRequired,
  textProps: PropTypes.object,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  hasBorder: PropTypes.bool,
  figcaption: PropTypes.string,
  cite: PropTypes.string,
};

QuoteComponent.defaultProps = {
  textProps: { component: 'h4' },
  color: Colors.neutral.grey54,
  borderColor: Colors.neutral.grey29,
  hasBorder: true,
};

export default QuoteComponent;
